import { render, staticRenderFns } from "./feature-card-research.vue?vue&type=template&id=700e8a0a&scoped=true&"
import script from "./feature-card-research.vue?vue&type=script&lang=js&"
export * from "./feature-card-research.vue?vue&type=script&lang=js&"
import style0 from "./feature-card-research.vue?vue&type=style&index=0&id=700e8a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e8a0a",
  null
  
)

export default component.exports